/**
 * Shared hint object
 * @param {string} originalDomain
 * @param {string} suggestedDomain
 * @param {string} code
 * @param {string} type
 * @returns {object} Data for hint object
 */
export default (originalDomain, suggestedDomain, code, type) => ({
	code,
	message: suggestedDomain ? `${originalDomain} | ${suggestedDomain}` : originalDomain,
	type
});
